<div class="ins-tabs">
  @for (tab of tabs; track tab) {
    <div class="ins-tab"
      [class.active]="tab.path === activeTab"
      [class.disabled]="tab.disabled"
      (click)="selectTab(tab)"
      (keydown.enter)="selectTab(tab)"
      (keypress)="$event.preventDefault()"
      (keyup)="$event.preventDefault()">
      {{ tab.label }}
    </div>
  }
</div>
